import styled from 'styled-components';

export const Main = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const PrintLabelWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
`;

export const Anchor = styled.a`
  text-decoration: none;
`;
